<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo"/>
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>

          <div class="tile internbackground painel">
            <div class="navbackground">
              <p>
                Olá, seja bem-vindo de volta,
                <span>{{name}}</span>!
              </p>
            </div>
            <div class="tile dash-painel flex-wrap columns is-mobile">
              <div class="column is-8">
                <article class="tile notification tiledash linkbox">
                  <p>Realizar Um Novo Cadastro</p>
                  <router-link :to="{ name: ''}">
                    <figure>
                      <div class="imagecontainer">
                        <img src="../../assets/images/icon-color/admin.svg" class alt="redonline" />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Administrador</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: 'admin/diretor'}">
                    <figure>
                      <div class="imagecontainer">
                        <img src="../../assets/images/icon-color/diretor.svg" class alt="redonline" />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Diretor</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: 'admin/corretor'}">
                    <figure>
                      <div class="imagecontainer">
                        <img src="../../assets/images/icon-color/writing.svg" class alt="redonline" />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Corretor</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: 'admin/escola'}">
                    <figure>
                      <div class="imagecontainer">
                        <img src="../../assets/images/icon-color/school.svg" class alt="redonline" />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Escola</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: 'admin/turma'}">
                    <figure>
                      <div class="imagecontainer">
                        <img src="../../assets/images/icon-color/turma.svg" class alt="redonline" />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Turma</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: 'aluno'}">
                    <figure>
                      <div class="imagecontainer">
                        <img
                          src="../../assets/images/icon-color/graduate-cap.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Aluno</caption>
                    </figure>
                  </router-link>
                </article>
              </div>
              <div class="column is-4">
                <div class="tile boxrotate notification bannerbox tiledash pink-gradient">
                  <b-icon class="icon-biblioteca"></b-icon>
                  <img class="balls" src="../../assets/images/icon-color/balls.png" />
                  <h3>PROPOSTAS SIMULADOS MATERIAIS COLETÂNEAS TEASER</h3>

                  <router-link :to="{ name: 'admin/biblioteca' }">
                    <div class="tile notification tiledashbox">
                      <h1>Gerenciar Biblioteca</h1>
                      <h2>Acessar</h2>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="column is-4">
                <article class="tile notification tiledash linkbox">
                  <p>Adicionar, Editar Ou Remover</p>
                  <div class="route-botons">
                    <router-link :to="{ name: 'redacao' }">
                      <figure>
                        <div class="imagecontainer">
                          <img
                            src="../../assets/images/icon-color/folhaderedacao.svg"
                            class
                            alt="redonline"
                          />
                          <b-icon class="icon-addcircle" type="hidden"></b-icon>
                        </div>
                        <caption>Redações</caption>
                      </figure>
                    </router-link>

                    <router-link :to="{ name: 'proposta' }">
                      <figure>
                        <div class="imagecontainer">
                          <img
                            src="../../assets/images/icon-color/new-document.svg"
                            class
                            alt="redonline"
                          />
                          <b-icon class="icon-addcircle" type="hidden"></b-icon>
                        </div>
                        <caption>Propostas</caption>
                      </figure>
                    </router-link>

                    <router-link :to="{ name: 'admin/simulado'}">
                      <figure>
                        <div class="imagecontainer">
                          <img
                            src="../../assets/images/icon-color/studying.svg"
                            class
                            alt="redonline"
                          />
                          <b-icon class="icon-addcircle" type="hidden"></b-icon>
                        </div>
                        <caption>Simulados</caption>
                      </figure>
                    </router-link>
                  </div>
                </article>
              </div>
              <div class="column is-4">
                <div class="tile boxrotate notification bannerbox tiledash orange-gradient">
                  <b-icon class="icon-gerenciar-usuarios"></b-icon>
                  <img class="balls" src="../../assets/images/icon-color/balls.png" />
                  <h3>PERMISSÕES CARGOS ADICIONAR REMOVER ATUALIZAR</h3>

                  <router-link :to="{ name: 'admin/user' }">
                    <div class="tile notification tiledashbox">
                      <h1>Gerenciar Usuários</h1>
                      <h2>Acessar</h2>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="column is-4">
                <div class="tile boxrotate notification tiledash bannerbox yellow-gradient">
                  <b-icon class="icon-creditos"></b-icon>
                  <img class="balls" src="../../assets/images/icon-color/balls.png" />
                  <h3>ADICIONE ATUALIZE REMOVA</h3>

                  <router-link :to="{ name: '' }">
                    <div class="tile notification tiledashbox">
                      <h1>Gerenciar Creditos</h1>
                      <h2>Acessar</h2>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <internfooter class="footer-painel" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import AuthService from "@/services/AuthService";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";

export default {
  data() {
    return {
      name: store.getters.name
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar
  },
  methods: {
    logout() {
      this.isLoading = true;
      AuthService.logout({})

        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "logout realizado com sucesso!",
            position: "is-top-right",
            type: "is-success"
          });
        })
        .catch(() => {})
        .finally(() => {});
    }
  }
};
</script>